// extracted by mini-css-extract-plugin
module.exports = {"section":"TelephonySection_section__cmR7g"};